var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"section-2__content"},[_c('Profile',{attrs:{"passwordEditRouterName":"TaskPasswordEdit","passwordChkouterName":"TaskPasswrodChk"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }